import { createReducer } from '@mews/framework';
import { UPDATE_SNACKBAR_HIDDEN, UPDATE_SNACKBAR_SHOWN } from '../actions/snackbars';

export default createReducer(
    { updateVisible: false },
    {
        [UPDATE_SNACKBAR_HIDDEN]: (state: $TSFixMe) => ({
            ...state,
            updateVisible: false,
        }),
        [UPDATE_SNACKBAR_SHOWN]: (state: $TSFixMe) => ({
            ...state,
            updateVisible: true,
        }),
    }
);
